module.exports = __webpack_public_path__ + "img/party-logo.400ed162.png";